import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import localforage from "localforage";
import { usePcr } from "../../context/PcrContext";
import MaxPainChart from "../MaxPainChart/MaxPainChart";
import { useStockName } from "../../context/StockNameContext";
import { useOption } from "../../context/OptionContext";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { FaSpinner } from "react-icons/fa6";
import { FiRefreshCw } from "react-icons/fi";
import "./PcrPage.css";

const CACHE_KEY = "ociCache";
const CACHE_DURATION = 5 * 60 * 1000;

const PcrPage = () => {
  const [pcrData, setPcrData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { symbol } = useParams();
  const { pcrStore, loadData, refresh } = usePcr();
  const [selectedExpiry, setSelectedExpiry] = useState("");
  const [selectOption, setSelectOption] = useState(null);
  const [selectedStrike, setSelectedStrike] = useState("");
  const [timeoutError, setTimeoutError] = useState(false);
  const [lastUpdated, setLastUpdated] = useState("");
  const { fetchStock, stockData } = useStockName();
  const {
    fetchBySymbol,
    optionData,
    expiries,
    pcr,

    error,
  } = useOption();

  // const data = pcrStore[symbol];
  const data = optionData
    ? {
        records: {
          expiryDates: expiries,
          underlyingValue: optionData.data.last_price,
          data: Object.entries(optionData.data.oc).map(([strike, v]) => ({
            strikePrice: Number(strike),
            CE: v.ce,
            PE: v.pe,
          })),
        },
      }
    : null;
  console.log("Data", data);
  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };
  const expiryDates = data?.records?.expiryDates;

  function getNearestExpiry(expiryDates) {
    if (!expiryDates || expiryDates.length === 0) return "";

    const today = new Date();

    const futureDates = expiryDates
      .map((date) => ({
        raw: date,
        parsed: new Date(date),
      }))
      .filter((d) => d.parsed >= today)
      .sort((a, b) => a.parsed - b.parsed);

    // If no future date found (all past), fallback to first in list
    return futureDates.length > 0 ? futureDates[0].raw : expiryDates[0];
  }
  const nearestExpiry = useMemo(
    () => getNearestExpiry(expiryDates),
    [expiryDates]
  );

  useEffect(() => {
    if (!symbol) return;

    console.log("🔍 Watching symbol:", symbol);
    if (!optionData) {
      fetchBySymbol(symbol);
      setLastUpdated(formatTimestamp());
    }
    if (!data) {
      setLoading(true);
      loadData(symbol);

      setLastUpdated(formatTimestamp());
      const timer = setTimeout(() => {
        if (!pcrStore[symbol]) {
          setTimeoutError(true);
          setLoading(false);
        }
      }, 20000);

      return () => clearTimeout(timer);
    } else {
      setLoading(false);
    }
  }, [symbol, data]);
  useEffect(() => {
    if (!symbol) return;

    console.log("Fetching stock for:", symbol);
    fetchStock(symbol);
  }, [symbol]);

  // Listen when context updates data
  useEffect(() => {
    if (!stockData) return;

    console.log("📈 Stock updated in context:", stockData);
  }, [stockData]);

  const activeExpiry = selectedExpiry || nearestExpiry;
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  console.log("Stock data from context", stockData);
  const companyName = stockData?.name;
  console.log("CompanyName", companyName);
  // const options = data?.filtered?.data;
  // const options = useMemo(() => {
  //   if (!data?.filtered?.data) return [];

  //   return data.filtered.data.filter((item) => {
  //     const matchExpiry = selectedExpiry
  //       ? item.expiryDate === selectedExpiry
  //       : true;

  //     const matchStrike = selectedStrike
  //       ? item.strikePrice === Number(selectedStrike)
  //       : true;

  //     return matchExpiry && matchStrike;
  //   });
  // }, [data, selectedExpiry, selectedStrike]);
  // const options = useMemo(() => {
  //   if (!data?.filtered?.data) return [];

  //   return data.filtered.data.filter((item) => {
  //     // CASE 1: Only strike selected (ignore expiry)
  //     if (selectedStrike && !selectedExpiry) {
  //       return item.strikePrice === Number(selectedStrike);
  //     }

  //     // CASE 2: Only expiry selected
  //     if (selectedExpiry && !selectedStrike) {
  //       return item.expiryDate === selectedExpiry;
  //     }

  //     // CASE 3: Both selected → match both
  //     if (selectedStrike && selectedExpiry) {
  //       return (
  //         item.strikePrice === Number(selectedStrike) &&
  //         item.expiryDate === selectedExpiry
  //       );
  //     }

  //     // CASE 4: Nothing selected → return everything
  //     return true;
  //   });
  // }, [data, selectedStrike, selectedExpiry]);
  const options = useMemo(() => {
    if (!data?.records?.data) return [];

    return data?.records?.data.filter((item) => {
      // CASE 1: Only strike selected (ignore expiry)
      if (selectedStrike && !selectedExpiry) {
        return item.strikePrice === Number(selectedStrike);
      }

      // CASE 2: Only expiry selected
      if (selectedExpiry && !selectedStrike) {
        return item.expiryDate === selectedExpiry;
      }

      // CASE 3: Both selected → match both
      if (selectedStrike && selectedExpiry) {
        return (
          item.strikePrice === Number(selectedStrike) &&
          item.expiryDate === selectedExpiry
        );
      }

      return true;
    });
  }, [data, selectedStrike, selectedExpiry]);
  const filteredOptions = useMemo(() => {
    if (!options) return [];

    return options.filter((item) => {
      // CASE 1: Only strike selected  → ignore expiry
      if (selectedStrike && !selectedExpiry) {
        return item.strikePrice === Number(selectedStrike);
      }

      // CASE 2: Only expiry selected → show all strikes of that expiry
      if (selectedExpiry && !selectedStrike) {
        return item.expiryDate === selectedExpiry;
      }

      // CASE 3: Both selected → strike AND expiry must match
      if (selectedStrike && selectedExpiry) {
        return (
          item.strikePrice === Number(selectedStrike) &&
          item.expiryDate === selectedExpiry
        );
      }

      // CASE 4: Nothing selected  → return full dataset
      return true;
    });
  }, [options, selectedStrike, selectedExpiry]);
  console.log("FilteredOptions", filteredOptions);
  console.log("Options", options);
  //   const options = useMemo(() => {
  //   if (!data?.records?.data) return [];

  //   return data?.records?.data.filter((item) => {
  //     // CASE 1: Only strike selected (ignore expiry)
  //     if (selectedStrike && !selectedExpiry) {
  //       return item.strikePrice === Number(selectedStrike);
  //     }

  //     // CASE 2: Only expiry selected
  //     if (selectedExpiry && !selectedStrike) {
  //       return item.expiryDate === selectedExpiry;
  //     }

  //     // CASE 3: Both selected → match both
  //     if (selectedStrike && selectedExpiry) {
  //       return (
  //         item.strikePrice === Number(selectedStrike) &&
  //         item.expiryDate === selectedExpiry
  //       );
  //     }

  //     return true;
  //   });
  // }, [data, selectedStrike, selectedExpiry]);
  // console.log("Filtered Options",filteredOptions);
  const ce = data?.filtered?.CE;
  const pe = data?.filtered?.PE;
  const underlying = data?.records?.underlyingValue;
  console.log("Underlyingvalue", underlying);
  const ceMaxOI =
    options && Math.max(...options?.map((item) => item.CE?.openInterest || 0));

  const peMaxOI =
    options && Math.max(...options.map((item) => item.PE?.openInterest || 0));
  console.log("CEMAX", ceMaxOI);
  console.log("peMAx", peMaxOI);

  const ceOI =
    options &&
    options
      .filter((item) => item?.CE)
      .reduce((sum, item) => sum + (item?.CE?.openInterest || 0), 0);
  const peOI =
    options &&
    options
      .filter((item) => item.PE)
      .reduce((sum, item) => sum + (item.PE.openInterest || 0), 0);

  console.log("Pcr", pcr);
  console.log("Expires", expiries);
  console.log("option data", data);
  const totCEOI = data?.filtered?.CE.totOI;
  console.log("TotalOI", totCEOI);
  const toPEOI = data?.filtered?.PE.totOI;
  console.log("TOTaloi for pe", toPEOI);

  function calculateMaxPain(options, underlying) {
    if (!options?.length) return null;

    // Filter out strikes having zero OI
    const validOptions = options.filter(
      (item) =>
        (item.CE?.openInterest || 0) > 0 || (item.PE?.openInterest || 0) > 0
    );

    if (!validOptions.length) return null;

    // Extract sorted strike prices
    const strikes = [...new Set(validOptions.map((i) => i.strikePrice))].sort(
      (a, b) => a - b
    );

    let minPain = Infinity;
    let maxPainStrike = null;

    // Calculate pain for each available strike
    strikes.forEach((strike) => {
      let totalPain = 0;

      validOptions.forEach((item) => {
        const ceOI = item.CE?.openInterest || 0;
        const peOI = item.PE?.openInterest || 0;
        const s = item.strikePrice;

        if (strike > s) totalPain += (strike - s) * ceOI;
        if (strike < s) totalPain += (s - strike) * peOI;
      });

      if (totalPain < minPain) {
        minPain = totalPain;
        maxPainStrike = strike;
      }
    });

    // Step 2: Round value (same as before)
    const roundedMaxPain = Math.round(maxPainStrike);

    // Step 3: If rounded value doesn't exist, map to closest available strike
    if (!strikes.includes(roundedMaxPain)) {
      const closestStrike = strikes.reduce((prev, curr) =>
        Math.abs(curr - roundedMaxPain) < Math.abs(prev - roundedMaxPain)
          ? curr
          : prev
      );

      return closestStrike;
    }

    return roundedMaxPain;
  }
  const handleExpiryChange = (e) => {
    setSelectedExpiry(e.target.value);
    setSelectedStrike("");
  };

  const handleStrikeChange = (e) => {
    setSelectedStrike(e.target.value);
    setSelectedExpiry("");
  };
  function calculateNiftyInvestMaxPain(options, underlying) {
    if (!options?.length) return null;

    // 0️⃣ Determine strike step size (50, 100, etc)
    // const strikeStep = options[1].strikePrice - options[0].strikePrice;
    const strikeStep =
      options && options.length > 1
        ? options[1].strikePrice - options[0].strikePrice
        : 0;

    // 1️⃣ Keep only ATM ± 10 strikes
    const filtered = options.filter(
      (item) => Math.abs(item?.strikePrice - underlying) <= strikeStep * 10
    );

    // 2️⃣ Remove dead/no liquidity strikes
    const liquidityFiltered = filtered.filter(
      (item) =>
        (item.CE?.openInterest || 0) > 200 || (item.PE?.openInterest || 0) > 200
    );

    // 3️⃣ Create smoothed effective OI (NiftyInvest logic shortcut)
    const processed = liquidityFiltered.map((item) => ({
      strikePrice: item.strikePrice,
      ceOI:
        (item.CE?.openInterest || 0) +
        0.5 * (item.CE?.changeinOpenInterest || 0),
      peOI:
        (item.PE?.openInterest || 0) +
        0.5 * (item.PE?.changeinOpenInterest || 0),
    }));

    // 4️⃣ Calculate Max Pain using effective OI
    const strikes = processed.map((i) => i.strikePrice);

    let minPain = Infinity;
    let maxPainStrike = null;

    strikes.forEach((strike) => {
      let pain = 0;

      processed.forEach((item) => {
        const s = item.strikePrice;

        // CALL pain: calls below strike are ITM
        if (strike > s) pain += (strike - s) * item.ceOI;

        // PUT pain: puts above strike are ITM
        if (strike < s) pain += (s - strike) * item.peOI;
      });

      if (pain < minPain) {
        minPain = pain;
        maxPainStrike = strike;
      }
    });

    // 5️⃣ Round to nearest strike step (like NiftyInvest)
    return Math.round(maxPainStrike / strikeStep) * strikeStep;
  }
  //built up function
  function getBuiltUp(changeInOI, priceChange) {
    if (changeInOI > 0 && priceChange > 0) return "LB"; // Long Built-Up
    if (changeInOI > 0 && priceChange < 0) return "SB"; // Short Built-Up
    if (changeInOI < 0 && priceChange > 0) return "SC"; // Short Covering
    if (changeInOI < 0 && priceChange < 0) return "LW"; // Long Unwinding
    return "-";
  }
  //built up color
  function getBuiltUpColor(code) {
    switch (code) {
      case "LB":
        return "#008A3E";
      case "SB":
        return "#C53030";
      case "SC":
        return "#C53030";
      case "LW":
        return "#C68A14";
      default:
        return "#fbbf24";
    }
  }

  const finalPain = calculateNiftyInvestMaxPain(options, underlying);
  console.log("FinalMaxpai", finalPain);
  const maxPain = calculateMaxPain(options, underlying);
  console.log("MaxPain", maxPain);
  // const strikeStep = options[1]?.strikePrice - options[0]?.strikePrice;
  const strikes = [...new Set(options?.map((item) => item.strikePrice))].sort(
    (a, b) => a - b
  );

  const strikeStep = strikes.length > 1 ? strikes[1] - strikes[0] : 0;

  const difference = Math.abs(underlying - maxPain);

  let sentimentTextColor = "black"; // default

  if (difference <= strikeStep) {
    sentimentTextColor = "#e6e6e6"; // neutral
  } else if (underlying < maxPain) {
    sentimentTextColor = "#2fd18a"; // bullish -> green text
  } else if (underlying > maxPain) {
    sentimentTextColor = "#ff4d4d"; // bearish -> red text
  }
  const ceMaxRow = options?.find((item) => item.strikePrice === maxPain)?.CE;
  const peMaxRow = options?.find((item) => item.strikePrice === maxPain)?.PE;

  const builtUpCE = getBuiltUp(
    ceMaxRow?.changeinOpenInterest,
    ceMaxRow?.change
  );
  const builtUpPE = getBuiltUp(
    peMaxRow?.changeinOpenInterest,
    peMaxRow?.change
  );
  const builtUpStyles = (signal) => {
    switch (signal) {
      case "LB":
        return { bg: "#d4f7e6", color: "#008A3E" };
      case "SB":
        return { bg: "#ffd4d4", color: "#C53030" };
      case "SC":
        return { bg: "#dce8ff", color: "#0047FF" };
      case "LW":
        return { bg: "#ffeac7", color: "#C68A14" };
      default:
        return { bg: "#f2f2f2", color: "#444" };
    }
  };

  const ceMaxRowBuiltUp = getBuiltUp(
    ceMaxRow?.changeinOpenInterest,
    ceMaxRow?.change
  );
  console.log("ceMaxRowBuiltup", ceMaxRowBuiltUp);
  const peMaxRowBuiltUp = getBuiltUp(
    peMaxRow?.changeinOpenInterest,
    peMaxRow?.change
  );
  const builtUpStyleCE = builtUpStyles(ceMaxRowBuiltUp);
  const builtUpStylePE = builtUpStyles(peMaxRowBuiltUp);
  const formatNumber = (num) => {
    if (num % 1 !== 0) {
      return num?.toFixed(2);
    }
    return num;
  };
  const getPCRSentiment = (pcr) => {
    let sentiment;
    let color; // Text color (dark shade)
    let bgColor; // Background (light shade)

    if (pcr < 0.7) {
      sentiment = "Bearish";
      color = "#C53030"; // Strong red
      bgColor = "#ffd4d4"; // Light red background
    } else if (pcr >= 0.7 && pcr <= 1.0) {
      sentiment = "Neutral";
      color = "#fbbf24";
      bgColor = "#EAEAEA"; // Light gray background
    } else if (pcr > 1.0 && pcr <= 1.3) {
      sentiment = "Bullish";
      color = "#008A3E"; // Dark green
      bgColor = "#d4f7e6"; // Light green background
    } else {
      sentiment = "Overly Bullish (Contrarian Risk)";
      color = "#856404"; // Golden/Brown text
      bgColor = "#FFF3CD"; // Soft yellow background
    }

    return { sentiment, color, bgColor };
  };

  const pcrSentimentColor = getPCRSentiment(pcr);
  const strikePrices = data?.records?.strikePrices;
  console.log("StrikePrice", strikePrices);
  const handleRefresh = async () => {
    if (!symbol) return;
    setLoading(true);
    await loadData(symbol);
    setLastUpdated(formatTimestamp());
    setLoading(false);
  };

  return (
    <>
      <div className="last-updated-head">
        {lastUpdated && <span>As on {lastUpdated}</span>}
        <FiRefreshCw
          onClick={handleRefresh}
          size={18}
          style={{
            cursor: "pointer",
            transition: "0.2s",
          }}
          onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
          onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
        />
      </div>
      {loading ? (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            color: "white",
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching Live data..{" "}
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      ) : timeoutError ? (
        <div
          style={{
            color: "white",
            textAlign: "center",
            marginTop: "40px",
          }}
        >
          <h2> Failed to load option chain data</h2>
        </div>
      ) : (
        <div>
          <div className="pcr-top-dropdown">
            <div className="select-option dropdown pcr-option">
              <label>Expiry Dates</label>
              <select
                onChange={handleExpiryChange}
                // value={selectOption || ""}
                value={activeExpiry || ""}
                style={{
                  backgroundColor: "#0f1720",
                  color: "white",
                  // fontWeight: 700,
                }}
              >
                {expiryDates?.map((item) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <span>OR</span>
            <div className="select-option dropdown pcr-option">
              <label>Strike</label>
              <select
                onChange={handleStrikeChange}
                value={selectedStrike || ""}
                style={{
                  backgroundColor: "#0f1720",
                  color: "white",
                  // fontWeight: 700,
                }}
              >
                <option value="">Select</option>
                <option
                  value=""
                  onClick={() => {
                    setSelectedExpiry("");
                    setSelectedStrike("");
                  }}
                >
                  Default
                </option>
                {strikePrices?.map((item) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div
            className="grid-1"
            style={{
              width: "360px",
              color: "white",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              textAlign: "left",
              marginTop: "10px",
            }}
          >
            <p>Company Name - {companyName}</p>
            <p>Stock Symbol - {symbol}</p>

            <p>
              Max Pain:{" "}
              <span style={{ fontWeight: "700", color: "#00e1b1" }}>
                {maxPain}
              </span>
            </p>

            <p>
              Underlying Price:
              <span style={{ fontWeight: "700", color: "#00b3ff" }}>
                {" "}
                {underlying}
              </span>
            </p>

            <p>
              PCR:{" "}
              <strong style={{ color: pcrSentimentColor.color }}>{pcr}</strong>
            </p>

            <p>
              Signal:{" "}
              <strong style={{ color: pcrSentimentColor.color }}>
                {" "}
                {pcrSentimentColor.sentiment}
              </strong>
            </p>
          </div>
          <div className="pcr-grid pcr-grid-layout">
            {/* <div className="grid built-up-grid">
              <h1
                style={{
                  color: "white",
                  fontWeight: "800",
                  textAlign: "left",
                }}
              >
                {" "}
                Built Up Abbreviation and Colors
              </h1>
              <ul
                style={{
                  listStyleType: "none",
                  paddingLeft: 0,
                  // marginTop: "20px",
                  textAlign: "left",
                }}
              >
                <li style={{ color: "#008A3E", marginBottom: "6px" }}>
                  <strong>LB</strong> – Long Built-Up (OI ↑ & Price ↑)
                </li>

                <li style={{ color: "#C53030", marginBottom: "6px" }}>
                  <strong>SB</strong> – Short Built-Up (OI ↑ & Price ↓)
                </li>

                <li style={{ color: "#0047FF", marginBottom: "6px" }}>
                  <strong>SC</strong> – Short Covering (OI ↓ & Price ↑)
                </li>

                <li style={{ color: "#C68A14", marginBottom: "6px" }}>
                  <strong>LW</strong> – Long Unwinding (OI ↓ & Price ↓)
                </li>
              </ul>
            </div> */}
            <div className="ce-pe">
              <div
                className="ce-pe1"
                // className="grid"
                // style={{
                //   display: "flex",
                //   justifyContent: "space-between",
                //   alignItems: "center",
                //   background: "#0f1720",
                //   padding: "18px 22px",
                //   // width: "260px",
                //   borderRadius: "12px",
                //   //   border: "1px solid #d8d8d8",
                //   textAlign: "center",
                //   boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                // }}
              >
                <div>
                  <h3
                  // style={{
                  //   fontSize: "18px",
                  //   fontWeight: "700",
                  //   color: "white",
                  //   marginBottom: "10px",
                  // }}
                  >
                    Ltp ({maxPain} CE)
                  </h3>

                  <div
                    className="ce-pe2"
                    style={{
                      background: ceMaxRow?.change >= 0 ? "#d4f7e6" : "#ffd4d4",
                      // padding: "10px 12px",
                      // borderRadius: "8px",
                      // fontWeight: "700",
                      // fontSize: "15px",
                      // display: "flex",
                      // gap: "10px",
                      // justifyContent: "center",
                      // alignItems: "center",
                      color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                    }}
                  >
                    {ceMaxRow?.lastPrice ?? "-"}{" "}
                    {ceMaxRow?.change >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ opacity: 0.8 }}>
                      {ceMaxRow?.change.toFixed(2) + "%" ?? "-"}
                    </span>
                  </div>
                </div>

                <div className="sub-grid">
                  <h3
                  // style={{
                  //   fontSize: "18px",
                  //   fontWeight: "700",
                  //   color: "white",
                  //   marginBottom: "10px",
                  // }}
                  >
                    Open Interest
                  </h3>
                  <div
                    className="ce-pe2"
                    style={{
                      // marginTop: "15px",
                      background:
                        ceMaxRow?.pchangeinOpenInterest >= 0
                          ? "#d4f7e6"
                          : "#ffd4d4",
                      // padding: "10px 12px",
                      // borderRadius: "8px",
                      // fontWeight: "700",
                      // fontSize: "15px",
                      // display: "flex",
                      // gap: "10px",
                      // justifyContent: "center",
                      // alignItems: "center",
                      color:
                        ceMaxRow?.pchangeinOpenInterest >= 0
                          ? "#008A3E"
                          : "#C53030",
                    }}
                  >
                    {formatNumber(ceMaxRow?.openInterest) ?? "-"}{" "}
                    {ceMaxRow?.pchangeinOpenInterest >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ opacity: 0.8 }}>
                      {ceMaxRow?.pchangeinOpenInterest.toFixed(2) + "%" ?? "-"}
                    </span>
                  </div>
                </div>
                <div className="sub-grid">
                  <h3
                  // style={{
                  //   fontSize: "18px",
                  //   fontWeight: "700",
                  //   color: "white",
                  //   marginBottom: "10px",
                  // }}
                  >
                    Built Up
                  </h3>
                  <div
                    className="ce-pe2"
                    style={{
                      // padding: "10px 12px",
                      // borderRadius: "8px",
                      // fontWeight: "700",
                      // fontSize: "15px",
                      // display: "flex",
                      // gap: "10px",
                      // justifyContent: "center",
                      // alignItems: "center",
                      backgroundColor: builtUpStyleCE.bg,
                      color: builtUpStyleCE.color,
                      // marginTop: "1rem",
                      // color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                    }}
                  >
                    {ceMaxRowBuiltUp}
                  </div>
                </div>

                {/* <div
                              style={{
                                padding: "10px 12px",
                                borderRadius: "8px",
                                fontWeight: "700",
                                fontSize: "15px",
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                                alignItems: "center",
            
                                marginTop: "1rem",
                                backgroundColor: builtUpSentimentCE.bg,
                                color: builtUpSentimentCE.color,
            
                                // color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                              }}
                            >
                              {builtUpSentimentCE?.label ?? "-"}
                            </div> */}
              </div>
              <div
                className="ce-pe1"
                // className="grid"
                // style={{
                //   display: "flex",
                //   justifyContent: "space-between",
                //   alignItems: "center",
                //   background: "#0f1720",
                //   padding: "18px 22px",
                //   // width: "260px",
                //   borderRadius: "12px",
                //   //   border: "1px solid #d8d8d8",
                //   textAlign: "center",
                //   boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
                // }}
              >
                <div>
                  <h3
                  // style={{
                  //   fontSize: "18px",
                  //   fontWeight: "700",
                  //   color: "white",
                  //   marginBottom: "10px",
                  // }}
                  >
                    Ltp ({maxPain} PE)
                  </h3>

                  <div
                    className="ce-pe2"
                    style={{
                      background: peMaxRow?.change >= 0 ? "#d4f7e6" : "#ffd4d4",
                      // padding: "10px 12px",
                      // borderRadius: "8px",
                      // fontWeight: "700",
                      // fontSize: "15px",
                      // display: "flex",
                      // gap: "10px",
                      // justifyContent: "center",
                      // alignItems: "center",
                      color: peMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                    }}
                  >
                    {peMaxRow?.lastPrice ?? "-"}{" "}
                    {peMaxRow?.change >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ opacity: 0.8 }}>
                      {peMaxRow?.change.toFixed(2) + "%" ?? "-"}
                    </span>
                  </div>
                </div>

                {/* OI box */}
                <div className="sub-grid">
                  <h3
                  // style={{
                  //   fontSize: "18px",
                  //   fontWeight: "700",
                  //   color: "white",
                  //   marginBottom: "10px",
                  // }}
                  >
                    Open Interest
                  </h3>
                  <div
                    className="ce-pe2"
                    style={{
                      // marginTop: "15px",
                      background:
                        peMaxRow?.pchangeinOpenInterest >= 0
                          ? "#d4f7e6"
                          : "#ffd4d4",
                      // padding: "10px 12px",
                      // borderRadius: "8px",
                      // fontWeight: "700",
                      // fontSize: "15px",
                      // display: "flex",
                      // gap: "10px",
                      // justifyContent: "center",
                      // alignItems: "center",
                      color:
                        peMaxRow?.pchangeinOpenInterest >= 0
                          ? "#008A3E"
                          : "#C53030",
                    }}
                  >
                    {formatNumber(peMaxRow?.openInterest) ?? "-"}
                    {peMaxRow?.pchangeinOpenInterest >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ opacity: 0.8 }}>
                      {peMaxRow?.pchangeinOpenInterest.toFixed(2) + "%" ?? "-"}
                    </span>
                  </div>
                </div>
                <div className="sub-grid">
                  <h3
                  // style={{
                  //   fontSize: "18px",
                  //   fontWeight: "700",
                  //   color: "white",
                  //   marginBottom: "10px",
                  // }}
                  >
                    Built Up
                  </h3>
                  <div
                    className="ce-pe2"
                    style={{
                      // padding: "10px 12px",
                      // borderRadius: "8px",
                      // fontWeight: "700",
                      // fontSize: "15px",
                      // display: "flex",
                      // gap: "10px",
                      // justifyContent: "center",
                      // alignItems: "center",
                      backgroundColor: builtUpStylePE.bg,
                      color: builtUpStylePE.color,
                      // marginTop: "1rem",
                    }}
                  >
                    {peMaxRowBuiltUp}
                  </div>
                </div>

                {/* <div
                              style={{
                                padding: "10px 12px",
                                borderRadius: "8px",
                                fontWeight: "700",
                                fontSize: "15px",
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: builtUpSentimentPE.bg,
                                color: builtUpSentimentPE.color,
                                marginTop: "1rem",
                              }}
                            >
                              {builtUpSentimentPE?.label ?? "-"}
                            </div> */}
              </div>
            </div>
            <div className="grid  built-up-grid built-mobile">
              <h1
                style={{
                  color: "white",
                  fontWeight: "800",
                  textAlign: "left",
                }}
              >
                {" "}
                Built Up Abbreviation and Colors
              </h1>
              <ul
                style={{
                  listStyleType: "none",
                  paddingLeft: 0,
                  // marginTop: "20px",
                  textAlign: "left",
                }}
              >
                <li style={{ color: "#008A3E", marginBottom: "6px" }}>
                  <strong>LB</strong> – Long Built-Up (OI ↑ & Price ↑)
                </li>

                <li style={{ color: "#C53030", marginBottom: "6px" }}>
                  <strong>SB</strong> – Short Built-Up (OI ↑ & Price ↓)
                </li>

                <li style={{ color: "#0047FF", marginBottom: "6px" }}>
                  <strong>SC</strong> – Short Covering (OI ↓ & Price ↑)
                </li>

                <li style={{ color: "#C68A14", marginBottom: "6px" }}>
                  <strong>LW</strong> – Long Unwinding (OI ↓ & Price ↓)
                </li>
              </ul>
            </div>

            {/* CALL BOX */}
            <div className="grid call-grid">
              <div className="div">
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "white",
                    marginBottom: "10px",
                  }}
                >
                  Ltp ({maxPain} CE)
                </h3>

                <div
                  style={{
                    background: ceMaxRow?.change >= 0 ? "#d4f7e6" : "#ffd4d4",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {ceMaxRow?.lastPrice ?? "-"}{" "}
                  {ceMaxRow?.change >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {ceMaxRow?.change.toFixed(2) + "%" ?? "-"}
                  </span>
                </div>
              </div>
              <div className="sub-grid">
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "white",
                    marginBottom: "10px",
                  }}
                >
                  Open Interest
                </h3>
                <div
                  style={{
                    marginTop: "15px",
                    background:
                      ceMaxRow?.pchangeinOpenInterest >= 0
                        ? "#d4f7e6"
                        : "#ffd4d4",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    color:
                      ceMaxRow?.pchangeinOpenInterest >= 0
                        ? "#008A3E"
                        : "#C53030",
                  }}
                >
                  {formatNumber(ceMaxRow?.openInterest) ?? "-"}{" "}
                  {ceMaxRow?.pchangeinOpenInterest >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {ceMaxRow?.pchangeinOpenInterest.toFixed(2) + "%" ?? "-"}
                  </span>
                </div>
              </div>
              <div className="sub-grid">
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "white",
                    marginBottom: "10px",
                  }}
                >
                  Built Up
                </h3>
                <div
                  style={{
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: builtUpStyleCE.bg,
                    color: builtUpStyleCE.color,
                    marginTop: "1rem",
                    // color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {ceMaxRowBuiltUp}
                </div>
              </div>

              {/* <div
                            style={{
                              padding: "10px 12px",
                              borderRadius: "8px",
                              fontWeight: "700",
                              fontSize: "15px",
                              display: "flex",
                              gap: "10px",
                              justifyContent: "center",
                              alignItems: "center",
          
                              marginTop: "1rem",
                              backgroundColor: builtUpSentimentCE.bg,
                              color: builtUpSentimentCE.color,
          
                              // color: ceMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                            }}
                          >
                            {builtUpSentimentCE?.label ?? "-"}
                          </div> */}
            </div>

            {/* PUT BOX */}
            <div className="grid call-grid">
              <div>
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "white",
                    marginBottom: "10px",
                  }}
                >
                  Ltp ({maxPain} PE)
                </h3>

                <div
                  style={{
                    background: peMaxRow?.change >= 0 ? "#d4f7e6" : "#ffd4d4",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    color: peMaxRow?.change >= 0 ? "#008A3E" : "#C53030",
                  }}
                >
                  {peMaxRow?.lastPrice ?? "-"}{" "}
                  {peMaxRow?.change >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {peMaxRow?.change.toFixed(2) + "%" ?? "-"}
                  </span>
                </div>
              </div>

              {/* OI box */}
              <div className="sub-grid">
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "white",
                    marginBottom: "10px",
                  }}
                >
                  Open Interest
                </h3>
                <div
                  style={{
                    // marginTop: "15px",
                    background:
                      peMaxRow?.pchangeinOpenInterest >= 0
                        ? "#d4f7e6"
                        : "#ffd4d4",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    color:
                      peMaxRow?.pchangeinOpenInterest >= 0
                        ? "#008A3E"
                        : "#C53030",
                  }}
                >
                  {formatNumber(peMaxRow?.openInterest) ?? "-"}
                  {peMaxRow?.pchangeinOpenInterest >= 0 ? (
                    <IoMdTrendingUp />
                  ) : (
                    <IoMdTrendingDown />
                  )}
                  <span style={{ fontSize: "16px", opacity: 0.8 }}>
                    {peMaxRow?.pchangeinOpenInterest.toFixed(2) + "%" ?? "-"}
                  </span>
                </div>
              </div>
              <div className="sub-grid">
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "white",
                    marginBottom: "10px",
                  }}
                >
                  Built Up
                </h3>
                <div
                  style={{
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: builtUpStylePE.bg,
                    color: builtUpStylePE.color,
                    marginTop: "1rem",
                  }}
                >
                  {peMaxRowBuiltUp}
                </div>
              </div>

              {/* <div
                            style={{
                              padding: "10px 12px",
                              borderRadius: "8px",
                              fontWeight: "700",
                              fontSize: "15px",
                              display: "flex",
                              gap: "10px",
                              justifyContent: "center",
                              alignItems: "center",
                              backgroundColor: builtUpSentimentPE.bg,
                              color: builtUpSentimentPE.color,
                              marginTop: "1rem",
                            }}
                          >
                            {builtUpSentimentPE?.label ?? "-"}
                          </div> */}
            </div>
          </div>
          <div className="stock-table-container" style={{ overflowX: "auto" }}>
            <table
              style={{ width: "100%", borderCollapse: "collapse" }}
              className="stock-table"
            >
              <thead>
                <tr>
                  <th
                    style={{
                      background: "#2fd18a",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    CALL OI
                  </th>
                  <th
                    style={{
                      background: "#2fd18a",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    CALL Chg OI
                  </th>
                  <th
                    style={{
                      background: "#2fd18a",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    CALL Vol
                  </th>
                  <th
                    style={{
                      background: "#2fd18a",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    CALL IV
                  </th>
                  <th
                    style={{
                      background: "#2fd18a",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    CALL LTP
                  </th>
                  <th
                    style={{
                      background: "#2fd18a",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    CALL Chg
                  </th>
                  <th
                    style={{
                      background: "#2fd18a",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    Built Up
                  </th>

                  <th
                    style={{
                      background: "#2fd18a",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    CALL PAIN
                  </th>
                  <th
                    style={{
                      background: "#f3f3f3",
                      color: "#000",
                      fontWeight: 700,
                    }}
                  >
                    PCR
                  </th>
                  {/* STRIKE COLUMN (Neutral) */}
                  <th
                    style={{
                      background: "#f3f3f3",
                      color: "#000",
                      fontWeight: 700,
                    }}
                  >
                    Strike
                  </th>

                  {/* PUT HEADERS (RED) */}
                  <th
                    style={{
                      background: "#ff4d4d",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    PUT Chg
                  </th>
                  <th
                    style={{
                      background: "#ff4d4d",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    PUT LTP
                  </th>
                  <th
                    style={{
                      background: "#ff4d4d",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    PUT IV
                  </th>
                  <th
                    style={{
                      background: "#ff4d4d",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    PUT Vol
                  </th>
                  <th
                    style={{
                      background: "#ff4d4d",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    PUT Chg OI
                  </th>
                  <th
                    style={{
                      background: "#ff4d4d",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    PUT OI
                  </th>
                  <th
                    style={{
                      background: "#ff4d4d",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    Built Up
                  </th>
                  <th
                    style={{
                      background: "#ff4d4d",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    PUT PAIN
                  </th>

                  {/* PCR (Neutral) */}

                  {/* <th
                style={{
                  background: "#f3f3f3",
                  color: "#000",
                  fontWeight: 700,
                }}
              >
                PAIN
              </th> */}
                </tr>
              </thead>

              <tbody>
                {/* {options?.map((item, idx) => { */}
                {filteredOptions?.map((item, idx) => {
                  const ceOI = item.CE?.openInterest || 0;
                  const peOI = item.PE?.openInterest || 0;
                  const rowPCR = ceOI > 0 ? (peOI / ceOI).toFixed(2) : "-";
                  // pcr += rowPCR;
                  const strike = item.strikePrice;

                  // 1️⃣ Find ATM strike
                  const isATM =
                    strike ===
                    options.reduce((prev, curr) =>
                      Math.abs(curr.strikePrice - underlying) <
                      Math.abs(prev.strikePrice - underlying)
                        ? curr
                        : prev
                    ).strikePrice;
                  const callPain =
                    underlying > strike ? (underlying - strike) * ceOI : 0;

                  const putPain =
                    strike > underlying ? (strike - underlying) * peOI : 0;

                  // 2️⃣ ITM CALL & PUT logic
                  const isITMCall = strike < underlying; // ITM CALL zone (left)
                  const isITMPut = strike > underlying; // ITM PUT zone (right)

                  //built for call
                  const callbuiltUp = getBuiltUp(
                    item?.CE?.changeinOpenInterest,
                    item.CE?.change
                  );
                  const putbuiltUp = getBuiltUp(
                    item.PE?.changeinOpenInterest,
                    item.PE?.change
                  );

                  // --- apply colors ---
                  const rowColor = isATM
                    ? "#cce5ff" // Blue ATM
                    : isITMCall || isITMPut
                    ? "#fff7c6" // Light yellow zone
                    : "transparent"; // Normal row
                  return (
                    <tr key={idx}>
                      <td>
                        <span
                          style={{
                            backgroundColor:
                              item?.CE?.openInterest === ceMaxOI
                                ? "#2fd18a"
                                : "transparent",
                            fontWeight:
                              item?.CE?.openInterest === ceMaxOI
                                ? "bold"
                                : "normal",
                            borderRadius: "10px",
                            padding: "1rem",
                          }}
                        >
                          {formatNumber(item.CE?.openInterest) ?? "-"}
                        </span>
                      </td>
                      <td>{item.CE?.changeinOpenInterest ?? "-"}</td>
                      <td>{item.CE?.totalTradedVolume ?? "-"}</td>
                      <td>{item.CE?.impliedVolatility ?? "-"}</td>
                      <td>{item.CE?.lastPrice ?? "-"}</td>
                      <td
                        style={{
                          color:
                            item.CE?.change?.toFixed(2) > 0
                              ? "#2fd18a"
                              : "#ff4d4d",
                        }}
                      >
                        {item.CE?.change?.toFixed(2) ?? "-"}
                      </td>
                      <td style={{ color: getBuiltUpColor(callbuiltUp) }}>
                        {callbuiltUp}
                      </td>
                      <td>{callPain.toFixed(2)}</td>
                      <td>
                        <strong>{rowPCR}</strong>
                      </td>
                      <td>
                        <strong style={{ color: "#0047FF" }}>
                          {item.strikePrice}
                        </strong>
                      </td>

                      <td
                        style={{
                          color:
                            item.PE?.change?.toFixed(2) > 0
                              ? "#2fd18a"
                              : "#ff4d4d",
                        }}
                      >
                        {item.PE?.change?.toFixed(2) ?? "-"}
                      </td>
                      <td>{item.PE?.lastPrice ?? "-"}</td>
                      <td>{item.PE?.impliedVolatility ?? "-"}</td>
                      <td>{item.PE?.totalTradedVolume ?? "-"}</td>
                      <td>{item.PE?.changeinOpenInterest ?? "-"}</td>

                      <td>
                        <span
                          style={{
                            backgroundColor:
                              item.PE?.openInterest === peMaxOI
                                ? "#ff4d4d"
                                : "transparent",
                            fontWeight:
                              item.PE?.openInterest === peMaxOI
                                ? "bold"
                                : "normal",
                            borderRadius: "10px",
                            padding: "1rem",
                          }}
                        >
                          {formatNumber(item.PE?.openInterest) ?? "-"}
                        </span>
                      </td>
                      <td style={{ color: getBuiltUpColor(putbuiltUp) }}>
                        {putbuiltUp}
                      </td>
                      <td>{putPain.toFixed(2)}</td>

                      {/* <td>{(callPain + putPain).toFixed(2)}</td> */}
                    </tr>
                  );
                })}

                <tr className="final-row-bottom">
                  <td>{formatNumber(ce?.totOI)}</td>
                  <td></td>
                  <td>{ce?.totVol}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Total</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{pe?.totVol}</td>
                  <td></td>
                  <td>{formatNumber(pe?.totOI)}</td>
                  <td></td>
                  <td
                    style={{
                      color:
                        toPEOI / totCEOI < 0.5
                          ? "#ff4d4d"
                          : toPEOI / totCEOI > 1.5
                          ? "#2fd18a"
                          : "#e6e6e6",

                      fontWeight: "bold",
                      borderRadius: "6px",
                      padding: "6px",
                      textAlign: "center",
                    }}
                  >
                    {(toPEOI / totCEOI).toFixed(2)}
                  </td>
                  {/* <td
                style={{
                  color: sentimentTextColor,
                  padding: "8px",
                  fontWeight: "600",
                  borderRadius: "6px",
                  textAlign: "center",
                }}
              >
                {finalPain}
              </td> */}
                  <td></td>
                </tr>
              </tbody>
            </table>

            {/* <div
              className="card"
              style={{
                padding: "10px",
                marginTop: "20px",

                borderRadius: "6px",
                fontSize: "14px",
                lineHeight: "1.6",
              }}
            >
              <h1 style={{ color: "white", fontWeight: "800" }}>Note</h1>
              <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                <li style={{ color: "green" }}>
                  <strong>LB</strong> – Long Built-Up (OI ↑ & Price ↑)
                </li>
                <li style={{ color: "red" }}>
                  <strong>SB</strong> – Short Built-Up (OI ↑ & Price ↓)
                </li>
                <li style={{ color: "blue" }}>
                  <strong>SC</strong> – Short Covering (OI ↓ & Price ↑)
                </li>
                <li style={{ color: "orange" }}>
                  <strong>LW</strong> – Long Unwinding (OI ↓ & Price ↓)
                </li>
              </ul>
            </div> */}
          </div>
          <div className="chart">
            <MaxPainChart
              processed={options}
              underlying={underlying}
              maxPain={maxPain}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default PcrPage;
